export const CHATS_RELATIVE_URL = '/dialogs/';
